module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-700.623e3205.woff";